"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var onboard_common_1 = require("@sovryn/onboard-common");
var types_1 = require("./types");
var UNSUPPORTED_METHOD = null;
function getInjectedInterface(identity) {
    var _this = this;
    return function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ({
                    provider: (window.ethereum.providers &&
                        Array.isArray(window.ethereum.providers)
                        ? window.ethereum.providers.find(function (provider) { return !!provider[identity]; })
                        : window.ethereum)
                })];
        });
    }); };
}
var metamask = {
    label: types_1.ProviderLabel.MetaMask,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider[types_1.ProviderIdentityFlag.MetaMask];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/metamask.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: getInjectedInterface(types_1.ProviderIdentityFlag.MetaMask),
    platforms: ['all']
};
var exodus = {
    label: types_1.ProviderLabel.Exodus,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider[types_1.ProviderIdentityFlag.Exodus];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/exodus.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: getInjectedInterface(types_1.ProviderIdentityFlag.Exodus),
    platforms: ['all']
};
var enkrypt = {
    label: types_1.ProviderLabel.Enkrypt,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider[types_1.ProviderIdentityFlag.Enkrypt];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/enkrypt.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: getInjectedInterface(types_1.ProviderIdentityFlag.Enkrypt),
    platforms: ['all']
};
var brave = {
    label: types_1.ProviderLabel.Brave,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider[types_1.ProviderIdentityFlag.BraveWallet];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/brave.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: getInjectedInterface(types_1.ProviderIdentityFlag.BraveWallet),
    platforms: ['all']
};
var binance = {
    label: types_1.ProviderLabel.Binance,
    injectedNamespace: types_1.InjectedNameSpace.Binance,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider[types_1.ProviderIdentityFlag.Binance];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/binance.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        var tempBNBProvider, addListener, provider;
        return __generator(this, function (_a) {
            tempBNBProvider = __assign({}, window.BinanceChain);
            window.BinanceChain = tempBNBProvider;
            addListener = window.BinanceChain.on.bind(window.BinanceChain);
            window.BinanceChain.on = function (event, func) {
                // intercept chainChanged event and format string
                if (event === 'chainChanged') {
                    addListener(event, function (chainId) {
                        var cb = func;
                        cb("0x".concat(parseInt(chainId).toString(16)));
                    });
                }
                else {
                    addListener(event, func);
                }
            };
            provider = (0, onboard_common_1.createEIP1193Provider)(window.BinanceChain, {
                eth_chainId: function (_a) {
                    var baseRequest = _a.baseRequest;
                    return baseRequest({ method: 'eth_chainId' }).then(function (id) { return "0x".concat(parseInt(id).toString(16)); });
                },
                // Unsupported method -- will throw error
                eth_selectAccounts: UNSUPPORTED_METHOD,
                wallet_switchEthereumChain: UNSUPPORTED_METHOD
            });
            provider.removeListener = function (event, func) { };
            return [2 /*return*/, {
                    provider: provider
                }];
        });
    }); },
    platforms: ['desktop']
};
var coinbase = {
    label: types_1.ProviderLabel.Coinbase,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return (!!provider && !!provider[types_1.ProviderIdentityFlag.Coinbase]) ||
            (!!provider && !!provider[types_1.ProviderIdentityFlag.CoinbaseExtension]);
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/coinbase.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        var provider, addListener;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getInjectedInterface(types_1.ProviderIdentityFlag.CoinbaseExtension)()];
                case 1:
                    provider = (_a.sent()).provider;
                    addListener = provider.on.bind(provider);
                    provider.on = function (event, func) {
                        // intercept chainChanged event and format string
                        if (event === 'chainChanged') {
                            addListener(event, function (chainId) {
                                var cb = func;
                                cb("0x".concat(parseInt(chainId).toString(16)));
                            });
                        }
                        else {
                            addListener(event, func);
                        }
                    };
                    return [2 /*return*/, { provider: provider }];
            }
        });
    }); },
    platforms: ['all']
};
var detected = {
    label: types_1.ProviderLabel.Detected,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider[types_1.ProviderIdentityFlag.Detected];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/detected.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ({
                    provider: window.ethereum
                })];
        });
    }); },
    platforms: ['all']
};
var trust = {
    label: types_1.ProviderLabel.Trust,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider &&
            !!provider[types_1.ProviderIdentityFlag.Trust] &&
            !!provider &&
            !provider[types_1.ProviderIdentityFlag.TokenPocket];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/trust.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ({
                    provider: (0, onboard_common_1.createEIP1193Provider)(window.ethereum, {
                        wallet_switchEthereumChain: UNSUPPORTED_METHOD,
                        eth_selectAccounts: UNSUPPORTED_METHOD
                    })
                })];
        });
    }); },
    platforms: ['mobile']
};
var opera = {
    label: types_1.ProviderLabel.Opera,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var device = _a.device;
        return device.browser.name === 'Opera';
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/opera.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ({
                    provider: (0, onboard_common_1.createEIP1193Provider)(window.ethereum, {
                        eth_requestAccounts: function (_a) {
                            var baseRequest = _a.baseRequest;
                            return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_b) {
                                return [2 /*return*/, baseRequest({ method: 'eth_accounts' })];
                            }); });
                        },
                        eth_selectAccounts: UNSUPPORTED_METHOD
                    })
                })];
        });
    }); },
    platforms: ['all']
};
var status = {
    label: types_1.ProviderLabel.Status,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider[types_1.ProviderIdentityFlag.Status];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/status.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        var provider;
        return __generator(this, function (_a) {
            provider = window.ethereum;
            return [2 /*return*/, {
                    provider: provider
                }];
        });
    }); },
    platforms: ['mobile']
};
var alphawallet = {
    label: types_1.ProviderLabel.AlphaWallet,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider[types_1.ProviderIdentityFlag.AlphaWallet];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/alphawallet.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ({
                    provider: (0, onboard_common_1.createEIP1193Provider)(window.ethereum, {
                        wallet_switchEthereumChain: UNSUPPORTED_METHOD,
                        eth_selectAccounts: UNSUPPORTED_METHOD
                    })
                })];
        });
    }); },
    platforms: ['mobile']
};
var atoken = {
    label: types_1.ProviderLabel.AToken,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider[types_1.ProviderIdentityFlag.AToken];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/atoken.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ({
                    provider: window.ethereum
                })];
        });
    }); },
    platforms: ['mobile']
};
var bitpie = {
    label: types_1.ProviderLabel.Bitpie,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function () { return !!window.Bitpie; },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/bitpie.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ({
                    provider: (0, onboard_common_1.createEIP1193Provider)(window.ethereum, {
                        wallet_switchEthereumChain: UNSUPPORTED_METHOD,
                        eth_selectAccounts: UNSUPPORTED_METHOD
                    })
                })];
        });
    }); },
    platforms: ['mobile']
};
var blockwallet = {
    label: types_1.ProviderLabel.BlockWallet,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider[types_1.ProviderIdentityFlag.BlockWallet];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/blockwallet.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: getInjectedInterface(types_1.ProviderIdentityFlag.BlockWallet),
    platforms: ['desktop']
};
var frame = {
    label: types_1.ProviderLabel.Frame,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider[types_1.ProviderIdentityFlag.Frame];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/frame.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ({
                    provider: window.ethereum
                })];
        });
    }); },
    platforms: ['desktop']
};
var huobiwallet = {
    label: types_1.ProviderLabel.HuobiWallet,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider[types_1.ProviderIdentityFlag.HuobiWallet];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/huobiwallet.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ({
                    provider: (0, onboard_common_1.createEIP1193Provider)(window.ethereum, {
                        wallet_switchEthereumChain: UNSUPPORTED_METHOD,
                        eth_selectAccounts: UNSUPPORTED_METHOD
                    })
                })];
        });
    }); },
    platforms: ['mobile']
};
var defiantwallet = {
    label: types_1.ProviderLabel.Defiant,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider[types_1.ProviderIdentityFlag.Defiant];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/defiantwallet.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ({
                    provider: (0, onboard_common_1.createEIP1193Provider)(window.ethereum, {
                        wallet_switchEthereumChain: UNSUPPORTED_METHOD,
                        eth_selectAccounts: UNSUPPORTED_METHOD
                    })
                })];
        });
    }); },
    platforms: ['mobile']
};
var hyperpay = {
    label: types_1.ProviderLabel.HyperPay,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    // Note: The property `hiWallet` is as of now the only known way of identifying hyperpay
    // wallet as it is a direct clone of metamask. `checkProviderIdentity` implementation is subject to
    // future changes
    checkProviderIdentity: function () { return !!window.hiWallet; },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/hyperpay.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ({
                    provider: (0, onboard_common_1.createEIP1193Provider)(window.ethereum, {
                        wallet_switchEthereumChain: UNSUPPORTED_METHOD,
                        eth_selectAccounts: UNSUPPORTED_METHOD
                    })
                })];
        });
    }); },
    platforms: ['mobile']
};
var imtoken = {
    label: types_1.ProviderLabel.ImToken,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider[types_1.ProviderIdentityFlag.ImToken];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/imtoken.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ({
                    provider: (0, onboard_common_1.createEIP1193Provider)(window.ethereum, {
                        wallet_switchEthereumChain: UNSUPPORTED_METHOD,
                        eth_selectAccounts: UNSUPPORTED_METHOD
                    })
                })];
        });
    }); },
    platforms: ['mobile']
};
var liquality = {
    label: types_1.ProviderLabel.Liquality,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider[types_1.ProviderIdentityFlag.Liquality];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/liquality.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        var provider;
        return __generator(this, function (_a) {
            provider = (0, onboard_common_1.createEIP1193Provider)(window.ethereum, {
                wallet_switchEthereumChain: UNSUPPORTED_METHOD,
                eth_selectAccounts: UNSUPPORTED_METHOD
            });
            provider.removeListener = function (event, func) { };
            return [2 /*return*/, { provider: provider }];
        });
    }); },
    platforms: ['desktop']
};
var meetone = {
    label: types_1.ProviderLabel.MeetOne,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && provider[types_1.ProviderIdentityFlag.MeetOne] === 'MEETONE';
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/meetone.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ({
                    provider: window.ethereum
                })];
        });
    }); },
    platforms: ['mobile']
};
var mykey = {
    label: types_1.ProviderLabel.MyKey,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider[types_1.ProviderIdentityFlag.MyKey];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/mykey.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ({
                    provider: window.ethereum
                })];
        });
    }); },
    platforms: ['mobile']
};
var ownbit = {
    label: types_1.ProviderLabel.OwnBit,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider[types_1.ProviderIdentityFlag.OwnBit];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/ownbit.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        var provider;
        return __generator(this, function (_a) {
            provider = (0, onboard_common_1.createEIP1193Provider)(window.ethereum, {
                eth_chainId: function (_a) {
                    var baseRequest = _a.baseRequest;
                    return baseRequest({ method: 'eth_chainId' }).then(function (id) { return "0x".concat(parseInt(id).toString(16)); });
                },
                wallet_switchEthereumChain: UNSUPPORTED_METHOD,
                eth_selectAccounts: UNSUPPORTED_METHOD
            });
            provider.removeListener = function (event, listener) { };
            provider.on = function (event, listener) { };
            return [2 /*return*/, { provider: provider }];
        });
    }); },
    platforms: ['mobile']
};
var tokenpocket = {
    label: types_1.ProviderLabel.TokenPocket,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider &&
            !!provider[types_1.ProviderIdentityFlag.TokenPocket] &&
            !provider[types_1.ProviderIdentityFlag.TP];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/tokenpocket.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function (_a) {
        var EventEmitter = _a.EventEmitter;
        return __awaiter(void 0, void 0, void 0, function () {
            var emitter, provider;
            return __generator(this, function (_b) {
                emitter = new EventEmitter();
                provider = (0, onboard_common_1.createEIP1193Provider)(window.ethereum, {
                    wallet_switchEthereumChain: function (_a) {
                        var baseRequest = _a.baseRequest, params = _a.params;
                        emitter.emit('chainChanged', params[0].chainId);
                        return baseRequest({
                            method: 'wallet_switchEthereumChain',
                            params: params
                        });
                    },
                    eth_selectAccounts: UNSUPPORTED_METHOD
                });
                provider.on = emitter.on.bind(emitter);
                return [2 /*return*/, {
                        provider: provider
                    }];
            });
        });
    },
    platforms: ['all']
};
var tp = {
    label: types_1.ProviderLabel.TP,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider[types_1.ProviderIdentityFlag.TP];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/tp.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ({
                    provider: (0, onboard_common_1.createEIP1193Provider)(window.ethereum, {
                        wallet_switchEthereumChain: UNSUPPORTED_METHOD,
                        eth_selectAccounts: UNSUPPORTED_METHOD
                    })
                })];
        });
    }); },
    platforms: ['mobile']
};
var xdefi = {
    label: types_1.ProviderLabel.XDEFI,
    injectedNamespace: types_1.InjectedNameSpace.XFI,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return provider &&
            provider.ethereum &&
            provider.ethereum[types_1.ProviderIdentityFlag.XDEFI];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/xdefi.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ({
                    provider: window.xfi && window.xfi.ethereum
                })];
        });
    }); },
    platforms: ['all']
};
var oneInch = {
    label: types_1.ProviderLabel.OneInch,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider[types_1.ProviderIdentityFlag.OneInch];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/oneInch.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ({
                    provider: (0, onboard_common_1.createEIP1193Provider)(window.ethereum)
                })];
        });
    }); },
    platforms: ['mobile']
};
var tokenary = {
    label: types_1.ProviderLabel.Tokenary,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider[types_1.ProviderIdentityFlag.Tokenary];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/tokenary.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ({
                    provider: (0, onboard_common_1.createEIP1193Provider)(window.ethereum)
                })];
        });
    }); },
    platforms: ['all']
};
var tally = {
    label: types_1.ProviderLabel.Tally,
    injectedNamespace: types_1.InjectedNameSpace.Tally,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider[types_1.ProviderIdentityFlag.Tally];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/tallywallet.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ({
                    provider: (0, onboard_common_1.createEIP1193Provider)(window.tally)
                })];
        });
    }); },
    platforms: ['desktop']
};
var rabby = {
    label: types_1.ProviderLabel.Rabby,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider[types_1.ProviderIdentityFlag.Rabby];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/rabby.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ({
                    provider: (0, onboard_common_1.createEIP1193Provider)(window.ethereum)
                })];
        });
    }); },
    platforms: ['desktop']
};
var mathwallet = {
    label: types_1.ProviderLabel.MathWallet,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider[types_1.ProviderIdentityFlag.MathWallet];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/mathwallet.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: getInjectedInterface(types_1.ProviderIdentityFlag.MathWallet),
    platforms: ['all']
};
var gamestop = {
    label: types_1.ProviderLabel.GameStop,
    injectedNamespace: types_1.InjectedNameSpace.GameStop,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider[types_1.ProviderIdentityFlag.GameStop];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/gamestop.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ({
                    provider: (0, onboard_common_1.createEIP1193Provider)(window.gamestop)
                })];
        });
    }); },
    platforms: ['desktop']
};
var bitkeep = {
    label: types_1.ProviderLabel.BitKeep,
    injectedNamespace: types_1.InjectedNameSpace.BitKeep,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider['ethereum'][types_1.ProviderIdentityFlag.BitKeep];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/bitkeep.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ({
                    provider: window.bitkeep && window.bitkeep.ethereum
                })];
        });
    }); },
    platforms: ['all']
};
var sequence = {
    label: types_1.ProviderLabel.Sequence,
    injectedNamespace: types_1.InjectedNameSpace.Ethereum,
    checkProviderIdentity: function (_a) {
        var provider = _a.provider;
        return !!provider && !!provider[types_1.ProviderIdentityFlag.Sequence];
    },
    getIcon: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./icons/sequence.js')); })];
            case 1: return [2 /*return*/, (_a.sent())["default"]];
        }
    }); }); },
    getInterface: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ({
                    provider: window.ethereum
                })];
        });
    }); },
    platforms: ['all']
};
var wallets = [
    exodus,
    enkrypt,
    metamask,
    binance,
    coinbase,
    defiantwallet,
    detected,
    trust,
    opera,
    status,
    alphawallet,
    atoken,
    bitpie,
    blockwallet,
    brave,
    frame,
    huobiwallet,
    hyperpay,
    imtoken,
    liquality,
    meetone,
    mykey,
    ownbit,
    tokenpocket,
    tp,
    xdefi,
    oneInch,
    tokenary,
    tally,
    rabby,
    mathwallet,
    gamestop,
    bitkeep,
    sequence,
];
exports["default"] = wallets;
